
      import API from "!../../../procollege/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../procollege/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../procollege/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../procollege/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../procollege/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../procollege/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../procollege/node_modules/css-loader/dist/cjs.js!../../../procollege/node_modules/vue-loader/dist/stylePostLoader.js!../../../procollege/node_modules/sass-loader/dist/cjs/index.js??clonedRuleSet-2.use[2]!../../../procollege/node_modules/vue-loader/dist/index.js??ruleSet[1].rules[5].use[0]!./announceEdit.vue?vue&type=style&index=0&id=75bbe88d&lang=scss";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;
options.insert = insertFn.bind(null, "head");
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../procollege/node_modules/css-loader/dist/cjs.js!../../../procollege/node_modules/vue-loader/dist/stylePostLoader.js!../../../procollege/node_modules/sass-loader/dist/cjs/index.js??clonedRuleSet-2.use[2]!../../../procollege/node_modules/vue-loader/dist/index.js??ruleSet[1].rules[5].use[0]!./announceEdit.vue?vue&type=style&index=0&id=75bbe88d&lang=scss";
       export default content && content.locals ? content.locals : undefined;
